import { css } from "@linaria/core";
import React from "react";
import { colors } from "../Theme";
import cx from "classnames";

const sizes = {
  s: "4px",
  m: "8px",
  l: "12px",
} as const;
type SpacingKeys = keyof typeof sizes;

interface Position {
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
}

interface MarkerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  color?: string;
  size?: SpacingKeys;
  position?: Position;
  visible?: boolean;
  className?: string;
}

const DefaultPosition = { top: "-1px", right: "-1px" } as const;

const Marker = ({
  children,
  color = colors.lightNitrogen500_Main,
  size = "m",
  position = DefaultPosition,
  visible = true,
  className,
  ...props
}: MarkerProps) => {
  const markerIndicatorStyle = React.useMemo<React.CSSProperties>(
    () => ({
      height: sizes[size],
      width: sizes[size],
      top: position.top || DefaultPosition.top,
      right: position.right || DefaultPosition.right,
      bottom: position.bottom || "auto",
      left: position.left || "auto",
      backgroundColor: color,
      transform: visible ? "scale(1)" : "scale(0)",
    }),
    [color, size, position, visible],
  );

  return (
    <div className={cx(className, markerWrapper)} {...props}>
      {children}
      <span className={markerIndicator} style={markerIndicatorStyle} />
    </div>
  );
};

export default Marker;

//#region CSS
const markerWrapper = css`
  position: relative;
  display: inline-block;
`;
const markerIndicator = css`
  position: absolute;
  display: block;
  content: "";
  border-radius: 50%;
  transition: transform 100ms cubic-bezier(0.64, 0.57, 0.67, 1.53);
`;
//#endregion CSS
